/**
 * CDD 문서용 Malaysia ID 표시 포맷.
 * - 숫자 12자리(하이픈/공백 제거 후) → XXXXXX-XX-XXXX
 * - 그 외(여권 등) → 원문 유지
 */
export function formatMalaysiaIdForCdd(raw: any): string {
  const s = String(raw ?? '').trim();
  if (!s) return '';
  const digits = s.replace(/\D/g, '');
  if (digits.length === 12) {
    return `${digits.slice(0, 6)}-${digits.slice(6, 8)}-${digits.slice(8)}`;
  }
  return s;
}
